<div class="db-dialog-wrapper" [ngClass]="{'db-dialog-wrapper_full-screen': fullScreen,'db-dialog-wrapper_full-screen-padding': fullScreenWithPadding, 'db-dialog-wrapper_no-border': noBorder, 'db-dialog-wrapper_animate-show': animateShow, 'db-dialog-wrapper_animate-hide': animateHide, 'db-dialog-wrapper_custom-scroll-screen': customScrollScreen}">
  <div class="db-dialog-wrapper__backdrop" [ngClass]="{'with-blur': withBlur, 'withBlackBlur': withBlackBlur}"
       (click)="closeByBackdrop()"
       id="db-dialog-wrapper__backdrop-bg"></div>
  <div  id="db-dialog-wrapper__external-close-button" class="db-dialog-wrapper__external-close-button"
        *ngIf="hasExternalCloseButton" (click)="close()">
    <i class="db-icon ds-close"></i>
  </div>
  <div class="db-dialog-wrapper__content-wrapper">
    <div class="db-dialog-wrapper__content {{className}}" [ngStyle]="{width: width, height: height}">
      <a [ngStyle]="{top: closeButtonTop, right: closeButtonRight}"
         *ngIf="hasCloseButton"
         class="db-dialog-wrapper__close-button"
         (click)="close()">
        <i id="db-dialog-wrapper__close-icon" class="db-icon db-icon-ds-close-small-arrow" [ngClass]="{'white': !!whiteCloseBtn}"></i>
      </a>

      <div class="db-dialog-wrapper__body {{whiteCloseBtn}}">
        <ng-content></ng-content>
        <ng-container [ngTemplateOutlet]="template"></ng-container>
      </div>
    </div>
  </div>
</div>
